import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mb-4" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "label-text required" }, "Nama Perubahan Harga", -1)
const _hoisted_3 = { class: "p-inputgroup flex-1" }
const _hoisted_4 = { class: "p-inputgroup-addon" }
const _hoisted_5 = { class: "invalid-feedback" }
const _hoisted_6 = { class: "mb-4" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "label-text required" }, "Versi Perubahan Harga", -1)
const _hoisted_8 = { class: "invalid-feedback" }
const _hoisted_9 = { class: "mb-4" }
const _hoisted_10 = { class: "grid grid-cols-2 gap-4" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "label-text required" }, "Tanggal Awal", -1)
const _hoisted_12 = { class: "invalid-feedback" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "label-text required" }, "Tanggal Akhir", -1)
const _hoisted_14 = { class: "invalid-feedback" }
const _hoisted_15 = { class: "mb-4" }
const _hoisted_16 = { class: "flex align-items-center" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", {
  for: "isactive",
  class: "ml-2"
}, " Memiliki tanggal berakhir ", -1)
const _hoisted_18 = { class: "container-btn-action" }
const _hoisted_19 = /*#__PURE__*/_createTextVNode("Kembali")
const _hoisted_20 = /*#__PURE__*/_createTextVNode("Simpan")

import InputText from 'primevue/inputtext'
import Button from 'primevue/button'
import Calendar from 'primevue/calendar'
import InputSwitch from 'primevue/inputswitch'
import Checkbox from 'primevue/checkbox'
import { DatePicker } from 'v-calendar'
import { Form, Field, FieldArray, ErrorMessage } from 'vee-validate'
import * as Yup from 'yup'
import { getCurrentInstance, onMounted, ref } from 'vue'
import { useStore } from 'vuex'
import moment from 'moment'
import apiUseCase from '@/usecase/apiUseCase'
import returnUrlPrams from '@/utils/helpers/returnUrlPrams'


export default /*#__PURE__*/_defineComponent({
  __name: 'PriceAdjustmentForm',
  setup(__props) {

const store = useStore()
const app = getCurrentInstance()
const {
  $toast, $strInd
} = app!.appContext.config.globalProperties

const moduleStore = 'hjpTable'
const detailPriceEndpoint = '/management/v1/MsDetilPrice'
const priceData = ref(store.state.hjpTable.modal.data)

const initialValues = {
  Name: '',
  Version: '',
  periodStart: '',
  periodEnd: '',
  hasEndDate: true,
  isActive: false
}

const schema = Yup.object().shape({
  Name: Yup.string().required('Nama Perubahan Harga harus diisi!')
    .max(30, 'Nama maksimal 30 karakter')
    .test('unique-name', 'Nama sudah digunakan', async (val) => {
      if (!val) return true
      try {
        const res = await apiUseCase.get(`${detailPriceEndpoint}/price-changes/${priceData.value.Id}${returnUrlPrams({
          search: `${priceData.value.Name}-${val}`,
          filterField: ['name']
        })}`)
        console.log('res', [res, val])
        const filterResult = res.result.filter((x: any) => x.Name === `${priceData.value.Name}-${val}`)
        console.log('filterResult', filterResult)
        if (priceData.value.Id) {
          return filterResult.length === 0 || `${priceData.value.Name}-${val}` === initialValues.Name
        } return filterResult.length === 0
      } catch (error) {
        return false
      }
    }),
  Version: Yup.string().required('Versi Perubahan Harga harus diisi!'),
  periodStart: Yup.string().required('Tanggal Awal harus diisi!'),
  periodEnd: Yup.string().required('Tanggal Akhir harus diisi!'),
})

const hideModalForm = () => {
  console.log('aaa')
  store.dispatch('setShowModalFormDl', false)
  console.log('store', store)
}

const onSubmit = (val: any) => {
  console.log(val)
  const arrPayload = []
  const payload = {
    msPriceId: priceData.value.Id,
    name: `${priceData.value.Name}-${val.Name}`,
    periodStart: `${moment(val.periodStart).format('YYYY-MM-DD')}T00:00:00+07:00`,
    periodEnd: val.hasEndDate ? `${moment(val.periodEnd).format('YYYY-MM-DD')}T00:00:00+07:00` : null,
    version: val.Version,
    isActive: false,
    isDelete: false
  }
  if (!val.hasEndDate) {
    delete payload.periodEnd
  }
  arrPayload.push(payload)
  console.log('payload', payload)
  // eslint-disable-next-line no-use-before-define
  prosesSubmit(payload)
}

const prosesSubmit = async (payload: any) => {
  const toastMessage = 'Perubahan Harga berhasil ditambahkan!'
  const response = await apiUseCase.postOrPut(`${detailPriceEndpoint}/price-change`, null, payload)
  console.log('response', response)
  if (!response.error) {
    store.dispatch('setShowModal', false)
    store.dispatch('setReloadDataList', true)
    // store.dispatch('setSelectedPassenger', dataForm.msPassengerId[0])
    $toast.add({
      severity: 'success',
      detail: toastMessage,
      group: 'bc',
      closable: false,
      life: 3000
    })
    hideModalForm()
    // store.dispatch('setReloadDataTable')
  } else {
    $toast.add({
      severity: 'error',
      detail: response.message,
      group: 'bc',
      closable: false,
      life: 3000
    })
  }
}

onMounted(async () => {
  console.log('store', store.state.hjpTable.modal.data)
  // getDataRoute()
  // getDataPassenger()
  const titleForm = 'Tambah'
  // if (store.state.hjpTable.modal.data) {
  //   await checkAddOrUpdate()
  //   titleForm = 'Edit'
  //   titleButton.value = 'Simpan perubahan'
  // }
  store.dispatch('setTitleFormSidebar', `${titleForm} Perubahan Harga`)
  console.log('priceData', priceData)
  // getDetailForm(store.state[moduleStore].modal.data.Id)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(Form), {
      onSubmit: onSubmit,
      "validation-schema": _unref(schema),
      "initial-values": initialValues,
      class: "form-container"
    }, {
      default: _withCtx(({ errors, setFieldValue, values }) => [
        _createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          _createVNode(_unref(Field), { name: "Name" }, {
            default: _withCtx(({ field, handleChange, handleBlur }) => [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("span", _hoisted_4, _toDisplayString(priceData.value.Name) + "-", 1),
                _createVNode(_unref(InputText), _mergeProps(field, {
                  modelValue: values.Name,
                  "onUpdate:modelValue": ($event: any) => ((values.Name) = $event),
                  onChange: handleChange,
                  onBlur: handleBlur,
                  class: `input-primary ${errors.Name ? 'input-invalid' : ''}`,
                  placeholder: "Tulis nama perubahan harga"
                }), null, 16, ["modelValue", "onUpdate:modelValue", "onChange", "onBlur", "class"])
              ])
            ]),
            _: 2
          }, 1024),
          _createElementVNode("div", _hoisted_5, _toDisplayString(errors.Name), 1)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createVNode(_unref(Field), { name: "Version" }, {
            default: _withCtx(({ field, handleChange, handleBlur }) => [
              _createVNode(_unref(InputText), _mergeProps(field, {
                modelValue: values.Version,
                "onUpdate:modelValue": ($event: any) => ((values.Version) = $event),
                onChange: handleChange,
                onBlur: handleBlur,
                class: `input-primary ${errors.Version ? 'input-invalid' : ''}`,
                placeholder: "Tulis versi perubahan harga"
              }), null, 16, ["modelValue", "onUpdate:modelValue", "onChange", "onBlur", "class"])
            ]),
            _: 2
          }, 1024),
          _createElementVNode("div", _hoisted_8, _toDisplayString(errors.Version), 1)
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", null, [
              _hoisted_11,
              _createVNode(_unref(Field), { name: "periodStart hidden-form" }, {
                default: _withCtx(({ field, handleChange, handleBlur }) => [
                  _createVNode(_unref(DatePicker), _mergeProps({
                    modelValue: values.periodStart,
                    "onUpdate:modelValue": ($event: any) => ((values.periodStart) = $event)
                  }, field, {
                    "onUpdate:modelValue": (val) => {
                if (val > values.periodEnd) {
                  setFieldValue('periodEnd', val)
                }
                setFieldValue('periodStart', val)
              },
                    masks: { input: 'DD/MM/YYYY' },
                    "min-date": _unref(moment)().toDate()
                  }), {
                    default: _withCtx(({ togglePopover, inputValue }) => [
                      _createVNode(_unref(InputText), {
                        id: "start-date",
                        "aria-describedby": "start-date-help",
                        placeholder: "DD/MM/YYYY",
                        value: inputValue,
                        class: _normalizeClass(`input-primary ${errors.periodStart ? 'input-invalid' : ''}`),
                        onClick: togglePopover,
                        readonly: ""
                      }, null, 8, ["value", "class", "onClick"])
                    ]),
                    _: 2
                  }, 1040, ["modelValue", "onUpdate:modelValue", "min-date"])
                ]),
                _: 2
              }, 1024),
              _createElementVNode("div", _hoisted_12, _toDisplayString(errors.periodStart), 1)
            ]),
            _createElementVNode("div", null, [
              _hoisted_13,
              (values.hasEndDate)
                ? (_openBlock(), _createBlock(_unref(Field), {
                    key: 0,
                    name: "periodEnd hidden-form"
                  }, {
                    default: _withCtx(({ field, handleChange, handleBlur }) => [
                      _createVNode(_unref(DatePicker), _mergeProps({
                        modelValue: values.periodEnd,
                        "onUpdate:modelValue": ($event: any) => ((values.periodEnd) = $event)
                      }, field, {
                        "onUpdate:modelValue": (val) => {
                if (val < values.periodStart) {
                  setFieldValue('periodStart', val)
                }
                setFieldValue('periodEnd', val)
              },
                        masks: { input: 'DD/MM/YYYY' },
                        "min-date": values.periodStart
                      }), {
                        default: _withCtx(({ togglePopover, inputValue }) => [
                          _createVNode(_unref(InputText), {
                            id: "end-date",
                            "aria-describedby": "end-date-help",
                            placeholder: "DD/MM/YYYY",
                            value: inputValue,
                            class: _normalizeClass(`input-primary ${errors.periodEnd ? 'input-invalid' : ''}`),
                            onClick: togglePopover,
                            readonly: ""
                          }, null, 8, ["value", "class", "onClick"])
                        ]),
                        _: 2
                      }, 1040, ["modelValue", "onUpdate:modelValue", "min-date"])
                    ]),
                    _: 2
                  }, 1024))
                : (_openBlock(), _createBlock(_unref(InputText), {
                    key: 1,
                    id: "end-date",
                    "aria-describedby": "end-date-help",
                    placeholder: "DD/MM/YYYY",
                    class: _normalizeClass(`input-primary ${errors.periodEnd ? 'input-invalid' : ''}`),
                    onClick: _ctx.togglePopover,
                    readonly: ""
                  }, null, 8, ["class", "onClick"])),
              _createElementVNode("div", _hoisted_14, _toDisplayString(errors.periodEnd), 1)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createVNode(_unref(Field), { name: "IsActive" }, {
            default: _withCtx(({ field }) => [
              _createElementVNode("div", _hoisted_16, [
                _createVNode(_unref(Checkbox), _mergeProps(field, {
                  modelValue: field.value,
                  "onUpdate:modelValue": ($event: any) => ((field.value) = $event),
                  binary: true,
                  inputId: "isactive",
                  name: "isactive"
                }), null, 16, ["modelValue", "onUpdate:modelValue"]),
                _hoisted_17
              ])
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_18, [
          _createVNode(_unref(Button), {
            class: "btn-back mr-2",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (hideModalForm()))
          }, {
            default: _withCtx(() => [
              _hoisted_19
            ]),
            _: 1
          }),
          _createVNode(_unref(Button), {
            type: "submit",
            class: "btn-primary mr-1"
          }, {
            default: _withCtx(() => [
              _hoisted_20
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["validation-schema"])
  ]))
}
}

})